export default __webpack_public_path__ + "static/media/FAQ_7_1.f7e839a5.png";